import React, { useCallback, useEffect, useState } from 'react';
import { Container, Card, CardBody, Row, Col, Nav, NavItem, NavLink, Badge, Spinner } from "reactstrap";
import { Link } from "react-router-dom";
import classnames from 'classnames';
import "../Templete/Tables/Styles/datatables.scss";
import "../Templete/Tables/Styles/customStyle.scss";
import { initialDataTable } from './tableColumn';
import { get } from '../../helpers/API';
import moment from 'moment'
import { handleStatusStyle } from '../../store/CustomFunctions';
import { TEXT_PROVIDER } from '../../Text';
import ServerSidePaginations from '../../components/Table/ServerSidePaginations';
import { TabProvider } from './TabProvider'

let initialValue = {
    sortBy: 'createdAt:desc',
    orderBy: 'approved',
    limit: 20,
    page: 0,
    total: 0,
    category: '',
    keywords: ''
}
const obj = {
    path: '/application/provider',
    title: "Provider",
    filter: "Provider"
}

const ProviderPage = (props) => {
    const [initialParams, setInitialParams] = useState(initialValue)
    const [dataSource, setDataSource] = useState(initialDataTable)
    const [activeTab, setActiveTab] = useState('1');
    const [loading, setLoading] = useState(() => false)

    const getProviders = useCallback((
        sortBy,
        orderBy,
        limit,
        page,
        total,
        category,
        keywords
    ) => {
        setLoading(true);
        setDataSource({
            ...initialDataTable,
            rows: [{
                name: <div className="d-flex align-items-center text-muted"><Spinner size="sm" className="mr-2" color="primary" />Loading...</div>
            }]
        })

        let params = ""
        let url = new URLSearchParams(params)

        url.set('_limit', limit)
        url.set('_start', page === 0 ? page : (page * 10) - 10)
        url.set('_sort', sortBy)

        get(`/nurse-applications/count?${url.toString()}`).then(count => {
            get(`/nurse-applications?${url.toString()}`).then(res => {
                const mapping = res.map((item, index) => {
                    return {
                        // index: page === 1 ? (index + 1) : (index + (10 * page) - 9),
                        name: <Link to={{ pathname: `/application/provider/${item.id}` }} className="text-dark font-weight-bold">{item.personal_information && item.personal_information.fullname ? item.personal_information.fullname : "-"}</Link>,
                        type: !item.registration_type ? "" : <>{item.registration_type.is_registered_nurse && <Badge className='mr-1' color="primary">Nurse</Badge>}
                            {item.registration_type.is_general_care_aide && <Badge className='mr-1' color="primary">Care Aide</Badge>}
                            {item.registration_type.is_medical_assistant && <Badge className='mr-1' color="primary">Medical Assistant</Badge>}
                            {item.registration_type.is_physiotherapist && <Badge className='mr-1' color="primary">Physio</Badge>}</>,
                        id_card: item.personal_information && item.personal_information.id_card ? item.personal_information.id_card : "-",
                        createdAt: item.personal_information && item.personal_information.createdAt ? moment(item.personal_information.createdAt).format("DD MMM YYYY") : "-",
                        checked_by: !item.checked_by ? "-" : item.checked_by.username,
                        contact_number: item.personal_information && item.personal_information.contact_number ? item.personal_information.contact_number : "-",
                        status: <span className={handleStatusStyle(item.status).badgeClass}>{handleStatusStyle(item.status).text2}</span>,
                        clickEvent: () => {
                            if (props.history !== undefined || props.history !== null) {
                                return props.history.push(`${obj.path}/${item.id}`)
                            }
                        }
                    }
                })

                setInitialParams({
                    sortBy,
                    orderBy,
                    limit,
                    page,
                    total: count,
                    category,
                    keywords
                })
                setDataSource({
                    ...initialDataTable,
                    rows: mapping
                })
                setLoading(false)
            }).catch(() => {
                setLoading(false)
            })
        }).catch(() => {
            setLoading(false);
        })
    }, [props.history])

    useEffect(() => {
        let mount = false;

        if (!mount) {
            getProviders(
                initialValue.sortBy,
                initialValue.orderBy,
                initialValue.limit,
                initialValue.page,
                initialValue.total,
                initialValue.category,
                initialValue.keywords
            )
        }

        return () => {
            mount = true
        }
    }, [getProviders]);

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>

                    <h4>{TEXT_PROVIDER}</h4>

                    <Row>
                        <Col lg={12}>
                            <Card>
                                <CardBody className="pt-0">


                                    <Nav tabs className="nav-tabs-custom mb-4">
                                        {TabProvider.map((item, index) => {
                                            return (
                                                <NavItem key={index}>
                                                    <NavLink onClick={() => { setActiveTab(item.key); }} className={classnames({ active: activeTab === item.key }, "font-weight-bold p-3")}>{item.name}</NavLink>
                                                </NavItem>
                                            )
                                        })}
                                    </Nav>

                                    <ServerSidePaginations
                                        loading={loading}
                                        dataSource={dataSource}
                                        getItems={(params) => {
                                            getProviders(
                                                params.sortBy,
                                                params.orderBy,
                                                params.limit,
                                                params.page,
                                                params.total,
                                                params.category,
                                                params.keywords
                                            )
                                        }}
                                        emptyMessage="There are no provider yet"
                                        obj={obj}
                                        initialParams={initialParams}
                                        setLoading={setLoading}
                                    />
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>

                </Container>
            </div>
        </React.Fragment>
    )
}

export default ProviderPage
